/**
 * Legacy redirect: Settings → Integrations → Settings → Flint AI.
 *
 * The page was renamed (it was always agent configuration, never third-party
 * connectors). Bookmarks, the bot's link-code hint, and any old deep links
 * land here and bounce to the new route. Safe to remove once V1.x analytics
 * show no traffic.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/settings/integrations/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/assistant" });
  },
});
